module.exports = __webpack_public_path__ + "static/media/edit-outlined.eabd311d.svg";